// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"742":"a1239686","887":"5c4961e0"}[chunkId] + ".css";
};